import { CabAssignComponent } from './cab-assign/cab-assign.component';
import { FleetManagementComponent } from './fleet-management/fleet-management.component';
import { MapTrackingComponent } from './map-tracking/map-tracking.component';
import { RosterGroupingComponent } from './roster-grouping/roster-grouping.component';
import { TrackingComponent } from './tracking/tracking.component';
import { SummaryComponent } from './summary/summary.component'

export const RosterNewDeclaration = [
    RosterGroupingComponent,
    CabAssignComponent,
    FleetManagementComponent,
    TrackingComponent,
    MapTrackingComponent,
    SummaryComponent
];